<div class="container">
    <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 tot-pad" *ngFor="let val of restaurantListByUser">
      <div class="viewDetailsStyle">
        <div class="addeve-sty">
          Select Restaurant
        </div>
        <div>
          <img class="cursor viedeatilsclose" style="position: absolute;" src="../../../../assets/icons/Info Circle.png" alt="" (click)="closeSelectResto()" />
        </div>
      </div>


      <div class="row restoviewdetailsheight">
        <div class="resttt">
          <div class="gry-col-vw">
            <div>
              <img [src]="val.logo" class="selectRestroDLogo" />
            </div>
  
            <div class="text-img view_details_text">
              <div class="fil-a">{{val.restaurantName}}</div>
              <div>
                <!-- <img src="../../../../assets/icons/heart-filled.png" /> -->
              </div>
            </div>
  
            <div style="" class="text-map view_details_addr">
              <span><img class="map-img" src="../../../../assets/icons/map-pin.svg" /></span>
              <div classs="text-george">
                {{val.address}}
              </div>
            </div>
  
            <div class="view_details_dateTime">
              <!-- <div class="checkForm">
                <span><img src="../../../../assets/icons/calendar-event.png" /></span>
                <div class="date-18">{{val.eventDate | date}}</div>
              </div>
  
              <div class="checkForm">
                <span><img src="../../../../assets/icons/clock-hour-3.png" /></span>
                <div class="time-01">{{val.deliveryTime}}</div>
              </div> -->
            </div>
  
            <div style="display: flex; justify-content: space-between; margin-top: 15px;" class="mobileepadd">
              <div>
                <button class="menu-btn" (click)="onclickmenu(val._id)">View Menu</button>
              </div>
  
              <div>
                <button class="loction-btn" (click)="viewLocation(val?.location?.coordinates)">View Location</button>
              </div>
            </div>
  
            <div style="display: flex; justify-content: center; margin-top: 15px;" *ngIf="val.isFreeDelivery == true">
              <div>
                <button class="free-btn">Free Delivery</button>
              </div>
            </div>
  
          </div>
        </div>
        

        <div style="display: flex; justify-content: space-between; gap: 20px;  padding-inline: 0;" class="padtop20">
          <div style="width: 35%;">
            <button class="back-btn" (click)="onclickback()">Go Back</button>
          </div>

          <div style="    width: 65%;">
            <button class="select-btn" (click)="selectRestaurantById(val._id, val)">Select</button>
          </div>
        </div>
      </div>
    </div>
</div>